import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const pLATFORM_ID = inject(PLATFORM_ID);

if(isPlatformBrowser(pLATFORM_ID)){

  if(localStorage.getItem("token")!==null){
    return true
  }
  else{
    router.navigate(['/login'])
    return false
  }
}
else{
  return false
}
};
export const loggedGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const pLATFORM_ID = inject(PLATFORM_ID);
if(isPlatformBrowser(pLATFORM_ID)){
  if(localStorage.getItem("token")!==null){
    router.navigate(['/home'])
    return false
  }
  else{

    return true
  }
}
else{
  return false
}
};

